import React from "react";
import Modal from "react-bootstrap/Modal";

const ClientModal = ({
  show,
  onClose,
  form,
  setForm,
  authData,
  clientError,
  onSubmit,
  handleStateChange,
  handleCityChange,
  disableSubmit,
  cities,
  states
}) => {

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Client / Party</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Row 1 */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>
              Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              value={form.name}
              onChange={(e) => setForm("name", e.target.value)}
            />
            {clientError?.name && (
              <div className="text-danger" style={{ fontSize: "12px" }}>{clientError.name}</div>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              value={form.email}
              onChange={(e) => setForm("email", e.target.value)}
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Mobile</label>
            <input
              type="number"
              className="form-control"
              value={form.phone}
              onChange={(e) => setForm("phone", e.target.value)}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Register No.</label>
            <input
              className="form-control"
              value={form.req_no}
              onChange={(e) => setForm("req_no", e.target.value)}
            />
          </div>
        </div>

        {/* Row 3 */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>PAN Card No.</label>
            <input
              className="form-control"
              value={form.pancard_no}
              onChange={(e) => setForm("pancard_no", e.target.value)}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>GST No.</label>
            <input
              className="form-control"
              value={form.gst}
              onChange={(e) => setForm("gst", e.target.value)}
            />
          </div>
        </div>

        {/* Row 4 - Address fields */}
        <div className="mb-3">
          <label>
            Address <span className="text-danger">*</span>
          </label>
          <input
            className="form-control"
            value={form.address}
            onChange={(e) => setForm("address", e.target.value)}
          />
          {clientError?.address && (
            <div className="text-danger" style={{ fontSize: "12px" }}>{clientError.address}</div>
          )}
        </div>

        <div className="mb-3">
          <label>Address 2</label>
          <input
            className="form-control"
            value={form.address_two}
            onChange={(e) => setForm("address_two", e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label>Address 3</label>
          <input
            className="form-control"
            value={form.address_three}
            onChange={(e) => setForm("address_three", e.target.value)}
          />
        </div>

        {/* Row 5 - Location */}
        <div className="row">
          <div className="col-md-4 mb-3">
            <label>
              State <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              value={form.state}
              onChange={handleStateChange}
            >
              <option value="">Select State</option>
              {states.map((s, i) => (
                <option key={s.id} value={s.name}>
                  {s.name}
                </option>
              ))}
            </select>
            {clientError?.state && (
              <div className="text-danger" style={{ fontSize: "12px" }}>{clientError.state}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>
              City <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              value={form.city}
              onChange={handleCityChange}
            >
              <option value="">Select City</option>
              {cities.map((c, i) => (
                <option key={c.id} value={c.name}>
                  {c.name}
                </option>
              ))}
            </select>
            {clientError?.city && (
              <div className="text-danger" style={{ fontSize: "12px" }}>{clientError.city}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>Pincode <span className="text-danger">*</span></label>
            <input
              type="number"
              className="form-control"
              value={form.pincode}
              onChange={(e) => setForm("pincode", e.target.value)}
            />
            {clientError?.pincode && (
              <div className="text-danger" style={{ fontSize: "12px" }}>{clientError.pincode}</div>
            )}
          </div>
        </div>

        {/* Row 6 */}
        <div className="mb-3">
          <label>Authorized Person</label>
          <select
            className="form-select"
            value={form.contact_person}
            onChange={(e) => setForm("contact_person", e.target.value)}
          >
            <option value="">Select Person</option>
            {authData?.map((p) => (
              <option key={p._id} value={p._id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ClientModal;
